import { Theme, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useOmnistore } from '../stores/Omnistore';

interface IEntityImageProps {
	entity: {
		name: string
		imageLink?: string
	}
	className: string | undefined
	tooltip?: string
}

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: theme.palette.common.white,
		color: 'rgba(0, 0, 0, 0.87)',
		boxShadow: theme.shadows[1],
		fontSize: 11,
	},
}))(Tooltip);

export const EntityImage = observer(({entity, className, tooltip} : IEntityImageProps) => {
	const omnistore = useOmnistore();
	if (tooltip === undefined) tooltip = entity.name;
	const rel = entity?.imageLink;
	if (!rel) return null;
	const src = rel.match(/^\/i\//) ? omnistore.authStore.baseUrl + rel : rel;
	return <LightTooltip title={tooltip} enterDelay={100}>
		<img className={className} alt={tooltip} src={src}/>
	</LightTooltip>;
});
